import { Text, VStack } from "native-base";
import React, { useState } from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";
import { useAppNavigation } from "@/hooks/application/navigation";
import { AuthNavigation } from "@/navigation/stacks/AuthenticationStack";

import SignupBySegmentModal from "../SignupBySegmentModal";

type ComponentProps = {
  modalVisible: boolean;
  onClose: () => void;
};

const WelcomeModal = ({ modalVisible, onClose }: ComponentProps) => {
  const { navigate } = useAppNavigation<AuthNavigation>();

  const [modalSegmentVisible, setModalSegmentVisible] = useState(false);

  const openModalSegment = () => {
    onClose();
    setModalSegmentVisible(true);
  };

  const closeModalSegment = () => {
    setModalSegmentVisible(false);
  };

  const goToLogin = () => {
    onClose();
    navigate("login");
  };

  return (
    <>
      <Modal
        isOpen={modalVisible}
        onClose={onClose}
        Header="Bem vindo ao iFeira"
        Body={
          <Text fontSize="lg">Para continuar usando nosso site, faça login ou cadastre-se.</Text>
        }
        Footer={
          <VStack w="full">
            <FormButton w="full" mb={22} onPress={openModalSegment}>
              Sou Novo
            </FormButton>
            <FormButton
              w="full"
              mb={22}
              colorScheme="white"
              textColor="primary.700"
              onPress={goToLogin}>
              Entrar
            </FormButton>
          </VStack>
        }
      />
      <SignupBySegmentModal modalVisible={modalSegmentVisible} onClose={closeModalSegment} />
    </>
  );
};

export default WelcomeModal;
